import { Box, Typography, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { WeekMenuProduct } from "../../../weekMenuTypes"
import { StandardDialog } from "../../../../../../../shared/components/dialogs/StandardDialog"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { ProductCard } from "./ProductCard"

const useStyles = makeStyles()(() => ({
    dialogPaper: {
        background: "white",
        borderRadius: ".75rem",
    },
    menuContainer: {
        padding: "3.5rem 2rem 2rem 2rem",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        gap: "1.5rem",
        width: "100%",
    },
    menuItem: {
        flex: "0 0 calc((100% - 3rem) / 3)",
        maxWidth: "calc((100% - 3rem) / 3)",
        minWidth: "17.5rem",
    },
    header: {
        padding: "0 2rem",
        gap: "0.5rem",
    },
}))

type TodaysOfferDetailsProps = {
    isOpen: boolean
    imageMode: "none" | "mixed" | "unknown"
    onClose: () => void
    displayDate: string
    weeklyOffers?: WeekMenuProduct[] | null
}

export function TodaysOfferDetails({ isOpen, imageMode, onClose, weeklyOffers, displayDate }: TodaysOfferDetailsProps) {
    const { classes } = useStyles()

    if (!weeklyOffers?.length) return null

    return (
        <StandardDialog
            // slotProps={{ paper: { className: classes.dialogPaper } }}
            // maxWidthProp="lg"
            scroll={"body"}
            isFullScreen
            open={isOpen}
            onClose={onClose}
        >
            <Stack className={classes.header} direction="row" alignItems="baseline">
                <LocalizedStrict id="user-home-week-menu-dialog-title">
                    <Typography color="#000000DE" variant="h4">
                        Todays menu
                    </Typography>
                </LocalizedStrict>
                <Typography variant="h6" fontWeight={500} color="#00000099">
                    {displayDate}
                </Typography>
            </Stack>
            <Box className={classes.menuContainer}>
                {weeklyOffers.map((offer) => (
                    <Box key={offer.id} className={classes.menuItem}>
                        <ProductCard onlyView extendDetails imageMode={imageMode} resource={offer} />
                    </Box>
                ))}
            </Box>
        </StandardDialog>
    )
}
